<div class="base base-desktop" [style.backgroundImage]="'url(' + overlay + ')'"></div>
<div class="base base-mobile" [style.backgroundImage]="'url(' + overlayMob + ')'"></div>
<div class="rows">
  <div class="row">
    <div class="track track-row-1">
      <img *ngFor="let p of row1" class="poster" [src]="p" alt="" />
    </div>
  </div>
  <div class="row">
    <div class="track track-row-2">
      <img *ngFor="let p of row2" class="poster" [src]="p" alt="" />
    </div>
  </div>
  <div class="row">
    <div class="track track-row-3">
      <img *ngFor="let p of row3" class="poster" [src]="p" alt="" />
    </div>
  </div>
</div>
<div class="overlay" [style.backgroundImage]="'url(' + overlay + ')'"></div>
